import { Form, Input, Select } from 'antd';
import { Rule } from 'antd/lib/form';
import React, { FC } from 'react';
import { UserGroup } from '../../../interfaces/UserInterface';
import Typography from '../../typography/Typography';

interface props {
  groups: UserGroup[];
  onGroupSelect: (groupId: string | undefined) => void;
}

const UserOnboardingForm: FC<props> = ({ groups, onGroupSelect }) => {
  const emailRules: Rule[] = [
    { required: true, message: 'Vul alstublieft een e-mailadres in' },
    { type: 'email', message: 'Ongeldig e-mailformaat' },
  ];

  const verticalLayoutProps = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  const handleGroupChange = (value: string) => {
    console.log(value);
    onGroupSelect(value);
  };

  return (
    <div className="grid grid-cols-3 gap-x-4">
      <div className="col-span-3">
        <Typography tag="h2" type="subtitle" addClass={'mb-2'}>
          Medewerker
        </Typography>
        <Typography tag="p" type="label">
          Deze gegevens worden gebruikt tijdens het registratieproces
        </Typography>
      </div>
      <div className="col-span-3 mt-2">
        <Form.Item
          name="geb_groep_id"
          label="Afdeling (groep)"
          rules={[
            {
              required: true,
              message: 'Selecteer alstublieft ten minste één groep',
            },
          ]}
          {...verticalLayoutProps}
        >
          <Select
            options={groups}
            onChange={handleGroupChange}
            placeholder="Selecteer groepen (bv. Sales Team, IT Support)"
            {...verticalLayoutProps}
          />
        </Form.Item>
      </div>

      <Form.Item
        name="geb_voornaam"
        label="Naam"
        rules={[{ required: true, message: 'Vul alstublieft een naam in' }]}
        {...verticalLayoutProps}
      >
        <Input placeholder="Voornaam" />
      </Form.Item>

      <Form.Item
        name="geb_naam"
        label="Familienaam"
        rules={[
          { required: true, message: 'Vul alstublieft een achternaam in' },
        ]}
        {...verticalLayoutProps}
      >
        <Input placeholder="Familienaam" />
      </Form.Item>

      <Form.Item
        name="email"
        label="E-mail"
        rules={emailRules}
        {...verticalLayoutProps}
      >
        <Input placeholder="example@cmcgroup.be" />
      </Form.Item>
    </div>
  );
};

export default UserOnboardingForm;
